import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import Box from '@mui/material/Box';
import Button from '../../../general/inputs/Button';
import { updateConsultation } from '../../../../routes/doctor/consultation';
import { setIsSettingsPopupOpened } from '../../../../redux/features/doctor/Dashboard/consultation/consultation';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import SettingsRow from './items/SettingsRow';
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined';
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import MotionPhotosAutoOutlinedIcon from '@mui/icons-material/MotionPhotosAutoOutlined';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { setIsRecorderBarDisabled } from '../../../../redux/features/doctor/Dashboard/consultation/consultationNote';
import { updateDoctorPreferences } from '../../../../routes/doctor/patients';
import CancelButton from '../../../general/inputs/CancelButton';

interface Props { 

}; 

const Settings: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 
    const isMobile = useMediaQuery('(max-width: 768px)');

    const { consultationId } = useParams(); 

    const colors = useAppSelector(state => state.theme.colors); 

    const isRecorderBarDisabled = useAppSelector(state => state.consultationNote.isRecorderBarDisabled); 
    

    // -- 

    const handleSettings = async (selectedSettingsCode: string) => { 

        dispatch(setIsSettingsPopupOpened(false)); 

    }; 

    // -- 

    const handleRecorderBar = async () => { 

        dispatch(setIsRecorderBarDisabled(!isRecorderBarDisabled)); 

        let content = {}; 

        if (isRecorderBarDisabled) { 

            content = { 
                consultation: { 
                    isRecorderBarEnabled: true
                }
            }; 

            dispatch(setNotificationMessage(t('recorderBarEnabled')));

        } else { 

            content = { 
                consultation: { 
                    isRecorderBarDisabled: true
                }
            }; 

            dispatch(setNotificationMessage(t('recorderBarDisabled')));

        }; 

        updateDoctorPreferences(content); 

    }; 

    // -- 

    const handleQuit = () => { 

        dispatch(setIsSettingsPopupOpened(false)); 

    }; 
    
    // -- 

    return (

        <Box 
            onClick={handleQuit}
            sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                width: '100vw',
                height: '100vh', 
                backgroundColor: colors?.popup, 
                overflow: 'hidden', 
                position: 'absolute', 
                zIndex: 100000000,
        }}>

            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center', 
                    gap: 1,
                    textAlign: 'center', 
                    width: '100%', 
                    maxWidth: isMobile ? '90vw' : '450px',
                    maxHeight: '80vh', 
                    padding: isMobile ? 2 : 3, 
                    borderRadius: isMobile ? 4 : 5,
                    fontSize: 14,
                    overflowX: 'hidden',
                    overflowY: 'auto', 
                    scrollbarWidth: 'none',
                    backgroundColor: colors?.container,
                }}
            >

                <Box
                    sx={{ 
                        width: '100%',
                        fontSize: 18, 
                        marginBottom: 2
                    }}
                >{t('settings')}

                </Box>

                <SettingsRow 
                    title='liveTranscription'
                    icon={<MotionPhotosAutoOutlinedIcon sx={{ color: colors?.main }} />}
                    // handler={handleConsent}
                    isDisabled
                    extraIcon={true ? <ToggleOnIcon sx={{ color: colors?.main }} /> : <ToggleOffOutlinedIcon sx={{ color: colors?.main }} />}
                />

                <SettingsRow 
                    title='recorderBar'
                    icon={<PlayCircleOutlineIcon sx={{ color: colors?.main }} />}
                    handler={handleRecorderBar}
                    extraIcon={isRecorderBarDisabled ? <ToggleOffOutlinedIcon sx={{ color: colors?.main }} /> : <ToggleOnIcon sx={{ color: colors?.main }} />}
                />

                <SettingsRow 
                    title='microphone'
                    icon={<MicNoneOutlinedIcon sx={{ color: colors?.main }} />}
                    extraIcon={<Box sx={{ color: 'rgb(150, 150, 150)' }}>{'Default'}</Box>}
                    isDisabled
                />

                <CancelButton handler={handleQuit} extraStyle={{ fontSize: 25, marginTop: 2 }} />

            </Box>

        </Box>

  );

};

export default Settings;